import {
    MapContainer,
    Marker,
    Popup,
    TileLayer,
    useMapEvents,
    LayersControl,
} from "react-leaflet";
import Sidebar from "../components/UI/Sidebar";
import { useMapStore } from "../store/mapStore";
import { useList } from "react-firebase-hooks/database";
import { ref } from "firebase/database";
import { db } from "../firebase";
import { Icon } from "leaflet";
import markerIconPng from "../assets/reddrone.png";
import userDroneMarkerPng from "../assets/droneMarker.png"
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getWeatherData, getZones, getalldrones, updateDroneLocation } from "../api/dronesAPI";
import { useAuthStore } from "../store/authStore";
import ZonesMapView from "./zonesMapView";
import { capitalize } from "../helpers/commonFunction";
import Legend from "../components/legends/legends";
import AirspaceDroneInfo from "../components/UI/airspace/airspaceDroneInfo";
import { ToastContainer, toast } from "react-toastify";
import { Cloud, Haze, Renew, Snow, Sun, Temperature, WatsonHealthImageAvailabilityLocal, WindGusts, Windy } from "@carbon/icons-react";
import AirspaceZoneInfo from "../components/UI/airspace/airspaceZoneInfo";

const AirspaceMap = () => {
    const [dronesData, loading, error] = useList(ref(db, "drones/"));
    const [fireDrones, setDrones] = useState([]);
    const [droneInfo, setDroneInfo] = useState({})
    const [showRefreshButton, setShowRefreshButton] = useState(true);
    const [currentPositionWeather, setCurrentPositionWeather] = useState(null);
    const [isClickedOnDroneMarker, setIsClickedOnDroneMarker] = useState(false)

    useEffect(() => {
        setDrones(dronesData.map((snap) => ({ droneId: snap.key, info: snap.val() })));
    }, [dronesData]);

    const { token, setLoaderState } = useAuthStore((state) => state)
    const { userDronesIdsStore, setUserDronesIdsStore, setStoreZones, storeZones, showZoneInfo, setShowZoneInfoPopup, showAirSpaceDroneInfo, setShowAirspaceDroneInfo } = useMapStore((state) => state)

    const { isLoading, data } = useQuery({
        queryFn: getalldrones,
        queryKey: ["getDrones", token, "approved"],
        refetchOnWindowFocus: false,
    });


    const zones = useQuery({
        queryFn: getZones,
        queryKey: ["zones", token],
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (zones.isLoading || isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [zones.isLoading, isLoading])

    useEffect(() => {
        if (data?.data?.data) {
            const dronesId = data?.data?.data?.map((drone) => {
                return drone.droneId
            })
            setUserDronesIdsStore(dronesId)
        }
    }, [data])
    const [position, setPosition] = useState({
        "lat": 26.667095801104814,
        "lng": 76.92626953125001
    });

    const weatherQuery = useMutation({
        mutationFn: getWeatherData,
    })

    useEffect(() => {
        if (position != null) {
            weatherQuery.mutate({ token, data: { lat: position.lat.toFixed(6), lng: position.lng.toFixed(6) } })
        }
    }, [position])

    useEffect(() => {
        setCurrentPositionWeather(weatherQuery?.data?.data?.data)
    }, [weatherQuery?.data?.data])

    function handleClick(e) {
        setIsClickedOnDroneMarker(false)
        setShowAirspaceDroneInfo(false)
        setPosition(e.latlng);
    }
    function LocationMarker() {
        useMapEvents({
            click(e) {
                handleClick(e);
            },
        });

        return position === null ? null : (
            <>
                {!isClickedOnDroneMarker && (<Popup position={position}>
                    {position.lat.toFixed(6)}, {position.lng.toFixed(6)}
                </Popup>)}

            </>
        );

    }

    const LegendData = [
        {
            title: "Other Drones",
            img: markerIconPng
        },
        {
            title: "Your Drones",
            img: userDroneMarkerPng
        }
    ]
    const refreshDroneLocation = useMutation({
        mutationFn: updateDroneLocation,
        // onError(err) {
        //   console.log(err)
        //   toast.error("incorrect otp")
        // }
    });


    useEffect(() => {
        if (!showRefreshButton) {
            setTimeout(() => {
                setShowRefreshButton(true)
            }, 300000)
        }
    }, [showRefreshButton])

    const RefreshLocationButton = () => {
        return (
            <div className="absolute right-32 flex items-center bottom-10 text-md text-center z-[1000] bg-black/50 backdrop-blur-sm text-white p-3 cursor-pointer rounded-full" onClick={() => {
                refreshDroneLocation.mutate({ droneId: userDronesIdsStore[0], token });
                toast.success("Location Updating in Every 6 seconds")
                setShowRefreshButton(false);
            }}>
                <Renew size={20} /> &nbsp; Refresh Drones

            </div>
        )
    }

    return (
        <>
            <div className="dash-wrap flex items-center h-screen py-4 pr-4 fixed w-full">
                <div className="side-bar">
                    <Sidebar />
                </div>
                <ToastContainer />
                <div>
                    <MapContainer className="z-10 opacity-80 text-inherit" center={[20.5937, 78.9629]} zoom={6} scrollWheelZoom={true}
                    >
                        {/* 
Gust 
Humidity
Lat 
Lon
 */}
                        {currentPositionWeather != null ? <div className="w-full ">
                            <div className="flex justify-center">
                                <div className=" h-fit absolute ml-auto mb-5 bottom-0 z-[10000] w-fit p-2">
                                    <div className="w-full flex justify-center">

                                        <div className="bg-black bg-opacity-70 h-fit w-fit flex mb-3 px-4 py-1 rounded-full">
                                            <div className="flex">
                                                <h1 className="text-zinc-400">LAT </h1>
                                                <h2 className="ml-2 text-white">{position?.lat.toFixed(6)}</h2>
                                            </div>
                                            <div className="flex ml-5">
                                                <h1 className="text-zinc-400">LNG </h1>
                                                <h2 className="ml-2 text-white">{position?.lng.toFixed(6)}</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="legend-item-1 rounded-full  bg-slate-100 flex space-x-10 pl-3 pr-8 py-1 items-center justify-between">
                                        <div className="ml-4 flex space-x-3">
                                            <div>
                                                {currentPositionWeather?.weather[0]?.main == "Clouds" ? <Cloud size={50} className="text-tblu font-extrabold" /> :
                                                    currentPositionWeather?.weather[0]?.main == "Clear" ? <Sun size={50} className="text-tblu font-extrabold" /> :
                                                        currentPositionWeather?.weather[0]?.main == "Clear" ? <Haze size={50} className="text-tblu font-extrabold" /> :
                                                            currentPositionWeather?.weather[0]?.main == "Snow" ? <Snow size={50} className="text-tblu font-extrabold" /> :
                                                                <Cloud size={50} className="text-tblu font-extrabold" />}
                                            </div>
                                            <div>
                                                <h1 className="font-extrabold text-base">{currentPositionWeather?.weather[0]?.main}</h1>
                                                <h2 className="text-center text-zinc-400">{currentPositionWeather?.weather[0]?.description}</h2>
                                            </div>
                                        </div>
                                        <div className="ml-4 ">
                                            <h1 className="font-extrabold text-base">Temprature</h1>
                                            <h2 className="text-center text-tblu text-lg flex items-center"><Temperature className="mr-1" />{currentPositionWeather?.main?.temp} &deg;C</h2>
                                        </div>
                                        <div className="ml-4 ">
                                            <h1 className="font-extrabold text-base">Location</h1>
                                            <h2 className="text-center text-tblu text-lg flex items-center"><WatsonHealthImageAvailabilityLocal className="mr-1" />{currentPositionWeather?.name}</h2>
                                        </div>
                                        <div className="ml-4 ">
                                            <h1 className="font-extrabold text-base">Wind Speed</h1>
                                            <h2 className="text-center text-tblu text-lg flex items-center"><Windy className="mr-1" />{currentPositionWeather?.wind?.speed}</h2>
                                        </div>
                                        <div className="ml-4 ">
                                            <h1 className="font-extrabold text-base">Gust</h1>
                                            <h2 className="text-center text-tblu text-lg flex items-center"><WindGusts className="mr-1" />{currentPositionWeather?.wind?.gust}</h2>
                                        </div>


                                    </div>



                                </div>
                            </div>


                        </div> : ""}
                        <TileLayer
                            attribution='Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                            url="https://api.mapbox.com/styles/v1/avi047/clggjhx5o003m01pe8j4x27a4/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYXZpMDQ3IiwiYSI6ImNsZzB1ZzViMjAwcG8zb2wyZGRjeWVlenkifQ.mSYEYtyu4CGsYyJU7jiXfw"
                        />
                        <LayersControl position='topright'>
                            <ZonesMapView />
                        </LayersControl>
                        {userDronesIdsStore && fireDrones.length !== 0 && fireDrones?.map((drone, index) => (
                            <Marker

                                key={index}
                                position={[
                                    drone.info.utm.currentPosition.lat,
                                    drone.info.utm.currentPosition.lng,
                                ]}
                                icon={
                                    new Icon({
                                        iconUrl: userDronesIdsStore?.includes(drone.droneId) ? userDroneMarkerPng : markerIconPng,
                                        iconSize: [50, 50],
                                        iconAnchor: [25, 25],
                                        zoomOffset: -4
                                    })
                                }
                                eventHandlers={{
                                    mouseover: (event) => event.target.openPopup(),
                                    mouseout: (event) => event.target.closePopup(),
                                    click: (e) => {
                                        setPosition({
                                            "lat": drone.info.utm.currentPosition.lat,
                                            "lng": drone.info.utm.currentPosition.lng
                                        })
                                        setIsClickedOnDroneMarker(true)
                                        setShowAirspaceDroneInfo(true);
                                        setDroneInfo({
                                            updatedOn: drone.info?.utm?.updatedAt,
                                            droneMission: drone.info?.currentMission?.missionName != "" ? drone.info?.currentMission?.missionName : "NA",
                                            droneId: drone.droneId,
                                            currentPosition: `${(drone.info.utm.currentPosition.lat)?.toFixed(8)} , ${(drone.info.utm.currentPosition.lng)?.toFixed(8)}`,
                                            droneName: drone.info.utm.droneName,
                                            droneCategory: drone.info.utm?.droneCategory,
                                            uin: drone.info.utm?.uin
                                        })
                                    }
                                }}
                            >
                                <Popup>
                                    <span className="font-extrabold">{capitalize(drone.info.utm.droneName)}</span>
                                    <br />
                                    <span>{drone.info.utm.currentPosition.lat},{drone.info.utm.currentPosition.lng}</span>
                                </Popup>
                            </Marker>
                        ))}
                        <LocationMarker />
                        {showRefreshButton ? <RefreshLocationButton /> : ""}
                        {showZoneInfo && <AirspaceZoneInfo />}
                        <Legend data={LegendData} />
                    </MapContainer>
                    <div className="absolute top-10 -right-20 z-[99999999] min-w-[50vw] max-w-full">

                        {showAirSpaceDroneInfo && <AirspaceDroneInfo updatedOn={droneInfo?.updatedOn} currentMission={droneInfo?.droneMission} currentPosition={droneInfo.currentPosition} droneId={droneInfo.droneId} droneName={droneInfo.droneName} droneCategory={droneInfo.droneCategory} uin={droneInfo.uin} />}
                    </div>
                </div>
            </div>
        </>
    )

}

export default AirspaceMap;